import { axiosInstance } from 'shared/config/axios';
import {
	GetGenerativeModelsRequest,
	CreateGenerativeModelRequest,
	UpdateGenerativeModelRequest,
	PostGenerativeModelFileRequest,
	GetGenerativeFilesRequest,
	DeleteGenerativeModelFileRequest,
	DeleteGenerativeModelRequest,
	GetGenerativeFileDetailsRequest,
	PutGenerativeLabelsRequest,
	GetGenerativeModelFileUrlRequest,
	GetGenerativeAiModelsRequest,
} from 'entities/generative-models/api/types';

export const getGenerativeModels: GetGenerativeModelsRequest = (queries) => {
	return axiosInstance.get('/generative-models', { params: { ...queries } });
};

export const postGenerativeModel: CreateGenerativeModelRequest = (data) => {
	return axiosInstance.post('/generative-models', data);
};

export const patchGenerativeModel: UpdateGenerativeModelRequest = ({ generativeModelId, data }) => {
	return axiosInstance.patch(`/generative-models/${generativeModelId}`, data);
};

export const deleteGenerativeModel: DeleteGenerativeModelRequest = ({ generativeModelId }) => {
	return axiosInstance.delete(`/generative-models/${generativeModelId}`);
};

export const getGenerativeModelFilesList: GetGenerativeFilesRequest = ({ generativeModelId }) => {
	return axiosInstance.get(`/generative-models/${generativeModelId}/files`);
};

export const postGenerativeModelFile: PostGenerativeModelFileRequest = ({ generativeModelId, data }) => {
	return axiosInstance.post(`/generative-models/${generativeModelId}/direct-uploading`, data, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const deleteGenerativeModelFile: DeleteGenerativeModelFileRequest = (data) => {
	return axiosInstance.delete('/generative-models/delete-files', { data });
};

export const getGenerativeFileDetails: GetGenerativeFileDetailsRequest = (generativeModelFileId) => {
	return axiosInstance.get(`/generative-models/file-labels/${generativeModelFileId}`);
};

export const putGenerativeLabels: PutGenerativeLabelsRequest = ({ generativeModelFileId, data }) => {
	return axiosInstance.put(`/generative-models/file-labels/${generativeModelFileId}`, data);
};

export const getGenerativeModelFileUrl: GetGenerativeModelFileUrlRequest = (generativeModelFileId) => {
	return axiosInstance.get(`/generative-models/file-url/${generativeModelFileId}`);
};

export const getGenerativeAiModels: GetGenerativeAiModelsRequest = () => {
	return axiosInstance.get('/generative-models/ai-models');
};
